export default class PageHero extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-page-hero', PageHero);
